// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"b9b54ad7","50":"92690bd6","136":"9f1d8098","585":"725bf09c","652":"31150a00","882":"8f4721ba","905":"c37a269a","967":"4ed0b856"}[chunkId] + ".chunk.js";
};